var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNewApp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M0 0h60v60H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F7F7F7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 11h14a5 5 0 015 5v1H17v-1a5 5 0 015-5zm14 39H22a5 5 0 01-5-5v-1h24v1a5 5 0 01-5 5zm-9-4a1 1 0 000 2h4a1 1 0 000-2h-4zM17 18h24v25H17z"
  })))));
}
export default SvgIconNewApp;